import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { Routes } from "@/router/Routes";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "root",
    redirect: to => {
      return "today";
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    redirect: to => {
      return "today";
    }
  },
  {
    path: Routes.TODAY.path,
    name: Routes.TODAY.name,
    component: () => import("../views/Today/Today.vue")
  },
  // {
  //   path: Routes.ORGANIZATION_SETTINGS.path,
  //   name: Routes.ORGANIZATION_SETTINGS.name,
  //   component: () => import("../views/OrganizationSettings.vue")
  // },
  {
    path: Routes.ACADEMY.path,
    name: Routes.ACADEMY.name,
    component: () => import("../views/academy/home/AcademyHomepage.vue")
  },
  // {
  //   path: Routes.ACADEMY_STORAGE_ORGANIZATION.path,
  //   name: Routes.ACADEMY_STORAGE_ORGANIZATION.name,
  //   component: () => import("../views/academy/storage/StoragePage.vue")
  // },
  {
    path: Routes.ACADEMY_STORAGE_ORGANIZATION_ROOT_FOLDER.path,
    name: Routes.ACADEMY_STORAGE_ORGANIZATION_ROOT_FOLDER.name,
    component: () => import("../views/academy/storage/StoragePage.vue")
  },
  {
    path: Routes.ACADEMY_STORAGE_ORGANIZATION_SUB_FOLDER.path,
    name: Routes.ACADEMY_STORAGE_ORGANIZATION_SUB_FOLDER.name,
    component: () => import("../views/academy/storage/StoragePage.vue")
  },
  {
    path: Routes.ACADEMY_STORAGE_PLAYER_ORGANIZATION.path,
    name: Routes.ACADEMY_STORAGE_PLAYER_ORGANIZATION.name,
    component: () => import("../views/academy/storage/StoragePage.vue")
  },
  {
    path: Routes.ACADEMY_STORAGE_PLAYER_ORGANIZATION_SUB_FOLDER.path,
    name: Routes.ACADEMY_STORAGE_PLAYER_ORGANIZATION_SUB_FOLDER.name,
    component: () => import("../views/academy/storage/StoragePage.vue")
  },
  {
    path: Routes.ACADEMY_ASSIGNMENT_ORGANIZATION.path,
    name: Routes.ACADEMY_ASSIGNMENT_ORGANIZATION.name,
    component: () => import("../views/academy/assignments/AssignmentsPage.vue")
  },
  {
    path: Routes.ACADEMY_ASSIGNMENT_PLAYER.path,
    name: Routes.ACADEMY_ASSIGNMENT_PLAYER.name,
    component: () => import("../views/academy/assignments/AssignmentsPage.vue")
  },
  {
    path: Routes.CREATE_REGISTRATION.path,
    name: Routes.CREATE_REGISTRATION.name,
    component: () =>
      import("../views/academy/createregistration/CreateRegistrationPage.vue"),
    meta: {
      liveChat: true
    }
  },
  {
    path: Routes.TEAM_REGISTRATION.path,
    name: Routes.TEAM_REGISTRATION.name,
    component: () =>
      import("../views/academy/teamregistration/TeamRegistrationPage.vue"),
    meta: {
      liveChat: true
    }
  },
  {
    path: Routes.PLAYER_REGISTRATION.path,
    name: Routes.PLAYER_REGISTRATION.name,
    component: () =>
      import("../views/academy/playerregistration/PlayerRegistrationPage.vue"),
    meta: {
      liveChat: true
    }
  },
  // {
  //   path: Routes.REGISTER.path,
  //   component: () =>
  //     import("../views/Registration/PlayerRegistration/index.vue"),
  //   children: Routes.REGISTER.children
  // },
  {
    path: Routes.PLAYER_REGISTRATION_TO_SPECIFIC_TEAM.path,
    name: Routes.PLAYER_REGISTRATION_TO_SPECIFIC_TEAM.name,
    component: () =>
      import("../views/academy/playerregistration/PlayerRegistrationPage.vue"),
    meta: {
      liveChat: true
    }
  },
  {
    path: Routes.PLAYER_REGISTRATION_DETAILS.path,
    name: Routes.PLAYER_REGISTRATION_DETAILS.name,
    component: () =>
      import("../views/academy/playerregistration/PlayerRegistrationPage.vue"),
    meta: {
      liveChat: true
    }
  },
  {
    path: Routes.PLAYER_REGISTRATION_DETAILS.path,
    name: Routes.PLAYER_REGISTRATION_DETAILS.name,
    component: () =>
      import("../views/academy/playerregistration/PlayerRegistrationPage.vue"),
    meta: {
      liveChat: true
    }
  },
  {
    path: Routes.PLAYER_REGISTRATION_TO_SPECIFIC_TEAM_DETAILS.path,
    name: Routes.PLAYER_REGISTRATION_TO_SPECIFIC_TEAM_DETAILS.name,
    component: () =>
      import("../views/academy/playerregistration/PlayerRegistrationPage.vue"),
    meta: {
      liveChat: true
    }
  },
  {
    path: Routes.RECORDINGS.path,
    name: Routes.RECORDINGS.name,
    component: () => import("../views/Recordings.vue")
  },
  {
    path: Routes.PAYMENTS.path,
    name: Routes.PAYMENTS.name,
    component: () => import("../views/payments/PaymentsPage.vue")
  },
  {
    path: Routes.BILLING.path,
    name: Routes.BILLING.name,
    component: () => import("../views/Billing.vue")
  },
  {
    path: Routes.EVENT_REGISTRATION.path,
    name: Routes.EVENT_REGISTRATION.name,
    component: () =>
      import("../views/academy/eventregistration/EventRegistrationPage.vue"),
    meta: {
      hideNavigation: true,
      liveChat: true
    }
  },
  {
    path: Routes.SUBSCRIPTIONS_SIGNUP.path,
    name: Routes.SUBSCRIPTIONS_SIGNUP.name,
    component: () =>
      import("../components/Subscriptions/SubscriptionSignupOrgSelection.vue")
  },
  {
    path: Routes.SUBSCRIPTIONS_LICENSES.path,
    name: Routes.SUBSCRIPTIONS_LICENSES.name,
    component: () =>
      import("../components/Subscriptions/SubscriptionLicenses.vue")
  },
  {
    path: Routes.SUBSCRIPTIONS_SELECT.path,
    name: Routes.SUBSCRIPTIONS_SELECT.name,
    component: () =>
      import("../components/Subscriptions/SubscriptionSelection.vue")
  },
  {
    path: Routes.SUBSCRIPTIONS_CHECKOUT.path,
    name: Routes.SUBSCRIPTIONS_CHECKOUT.name,
    component: () =>
      import("../components/Subscriptions/SubscriptionCheckout.vue")
  },
  {
    path: Routes.ORGANIZATIONS.path,
    name: Routes.ORGANIZATIONS.name,
    component: () => import("../views/OrganizationOverview.vue")
  },
  {
    path: Routes.CHAT.path,
    name: Routes.CHAT.name,
    component: () => import("../views/Chat/Chat.vue")
  },
  {
    path: Routes.HEALTHCHECK.path,
    name: Routes.HEALTHCHECK.name,
    component: () => import("../views/HealthCheck.vue")
  },
  {
    path: Routes.HEALTHREVIEW.path,
    name: Routes.HEALTHREVIEW.name,
    component: () => import("../views/HealthReview.vue")
  },
  {
    path: Routes.CREATETEAM.path,
    name: Routes.CREATETEAM.name,
    component: () => import("../views/CreateTeam.vue")
  },
  {
    path: Routes.FAN_PLAYERS.path,
    name: Routes.FAN_PLAYERS.name,
    component: () => import("../views/Team/TeamViews/FanPlayers.vue")
  },
  {
    path: Routes.COACH_TEAMS.path,
    name: Routes.COACH_TEAMS.name,
    component: () => import("../views/Team/TeamViews/CoachViewContainer.vue")
  },
  {
    path: Routes.FAN_CALENDAR.path,
    name: Routes.FAN_CALENDAR.name,
    component: () => import("../views/Calendar/CalendarViews/FanCalendar.vue")
  },
  {
    path: Routes.TEAM_CALENDAR.path,
    name: Routes.TEAM_CALENDAR.name,
    component: () => import("../views/Calendar/CalendarViews/TeamCalendar.vue")
  },
  {
    path: Routes.ADMIN.path,
    name: Routes.ADMIN.name,
    component: () => import("../views/Admin.vue"),
    children: [
      {
        path: Routes.ADMIN.children.REPORTS.path,
        name: Routes.ADMIN.children.REPORTS.name,
        component: () => import("../views/Admin/Reports.vue"),
        children: [
          {
            path:
              Routes.ADMIN.children.REPORTS.children.ORGANIZATIONSUBSCRIPTIONS
                .path,
            name:
              Routes.ADMIN.children.REPORTS.children.ORGANIZATIONSUBSCRIPTIONS
                .name,
            component: () =>
              import("../views/Admin/Reports/OrganizationSubscriptions.vue")
          },
          {
            path: Routes.ADMIN.children.REPORTS.children.ORGLIST.path,
            name: Routes.ADMIN.children.REPORTS.children.ORGLIST.name,
            component: () => import("../views/Admin/Reports/OrgList.vue")
          },
          {
            path: Routes.ADMIN.children.REPORTS.children.STATS.path,
            name: Routes.ADMIN.children.REPORTS.children.STATS.name,
            component: () => import("../views/Admin/Reports/Stats.vue")
          }
        ]
      },
      {
        path: Routes.ADMIN.children.MANDRILL.path,
        name: Routes.ADMIN.children.MANDRILL.name,
        component: () => import("../views/Admin/Mandrill.vue")
      }
    ]
  },
  {
    path: Routes.FAN_EMAIL.path,
    name: Routes.FAN_EMAIL.name,
    component: () => import("../views/Email.vue")
  },
  {
    path: Routes.TEAM_EMAIL.path,
    name: Routes.TEAM_EMAIL.name,
    component: () => import("../views/Email.vue")
  },
  {
    path: Routes.CHECKOUT_PAGE.path,
    name: Routes.CHECKOUT_PAGE.name,
    component: () => import("../views/payments/CheckoutPage.vue"),
    meta: {
      requiresAuth: false,
      hideNavigation: true
    }
  },
  {
    path: Routes.NOT_FOUND.path,
    name: Routes.NOT_FOUND.name,
    component: () => import("../views/NotFound.vue")
  }
];

const router = new VueRouter({
  routes,
  mode: "history"
});

// router.afterEach((to, from) => {
//   setTimeout(() => {
//     const chatWidget = document.querySelector("chat-widget");
//     if (!chatWidget) return;
//     if (to.meta.liveChat) {
//       //@ts-ignore
//       chatWidget.show();
//     } else {
//       //@ts-ignore
//       chatWidget.hide();
//     }
//   }, 2000);
// });

export default router;
